import { apiV1 } from "api-v2";
import type {
	AddProjectToCompareParams,
	RemoveProjectFromCompareParams,
} from "../types/supplier-search.types";

const unwrap = <T>(responseData: unknown): T => {
	if (
		responseData &&
		typeof responseData === "object" &&
		"data" in responseData
	) {
		return (responseData as Record<string, unknown>).data as T;
	}
	return responseData as T;
};

export const addProjectToCompare = async (
	params: AddProjectToCompareParams
): Promise<unknown> => {
	const { groupId, companyId, projectId, slot } = params;
	const response = await apiV1.patch(
		`groups/${groupId}/compare-list/add_project_to_company/${companyId}/${projectId}/${slot}`,
		{}
	);
	return unwrap(response.data);
};

export const removeProjectFromCompare = async (
	params: RemoveProjectFromCompareParams
): Promise<unknown> => {
	const { groupId, companyId, projectId, slot } = params;
	const response = await apiV1.patch(
		`groups/${groupId}/compare-list/remove_project_from_company/${companyId}/${projectId}/${slot}`,
		{}
	);
	return unwrap(response.data);
};
